export default __webpack_public_path__ + "static/media/traslado.279787cb.svg";